export default __webpack_public_path__ + "static/media/bounce.2bb3408b.svg";